"use client";

import { useState } from "react";

/** Copies the article URL — Instagram has no public web share endpoint. */
export function CopyShareLink({
  url,
  label = "کپی لینک",
}: {
  url: string;
  label?: string;
}) {
  const [done, setDone] = useState(false);

  return (
    <button
      type="button"
      className="wb-go wb-go--compact"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(url);
          setDone(true);
          window.setTimeout(() => setDone(false), 2000);
        } catch {
          window.prompt("لینک مطلب را کپی کنید:", url);
        }
      }}
    >
      {done ? "کپی شد" : label}
    </button>
  );
}
